module.exports = __webpack_public_path__ + "static/img/planet2.a73980e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/planet/planet2.png
// module id = gIas
// module chunks = 1